import { getRentTotal } from "web_myplann/Goals/Helpers/getRentTotal";
import {
	calcPerpetualRentMonthly,
	calcRentToZeroMonthly,
} from "web_myplann/Goals/Helpers/rentCalculation";
import { RentDrawdownMode } from "web_myplann/Goals/Types/RentDrawdownMode";

type PrivateRentMonthlyInput = {
	price: number | null | undefined;
	monthlyRent: number;
	drawdownMode: RentDrawdownMode;
	rentYears: number;
};

export const getPrivateRentMonthly = ({
	price,
	monthlyRent,
	drawdownMode,
	rentYears,
}: PrivateRentMonthlyInput): number => {
	if (price == null || price <= 0) return monthlyRent;

	const funded =
		drawdownMode === RentDrawdownMode.Perpetual
			? calcPerpetualRentMonthly(price)
			: calcRentToZeroMonthly(price, rentYears);

	if (funded <= 0) return monthlyRent;
	if (monthlyRent <= 0) return funded;

	const fundedPrice = getRentTotal({
		monthly: funded,
		drawdownMode,
		rentYears,
	});

	return fundedPrice === price ? funded : monthlyRent;
};
